import chroma from "chroma-js";
import { StaticColor } from "views/logic/views/formatting/highlighting/HighlightingColor";
export const FULL_MESSAGE_FIELD = "full_message";
export const TIMESTAMP_FIELD = "timestamp";
export const MESSAGE_FIELD = "message";
export const SOURCE_FIELD = "source";
export const STREAMS_FIELD = "streams";
export const GL2_SECOND_SORT_FIELD = "gl2_second_sort_field";
export const FILTERED_FIELDS = [
  // ElasticSearch fields.
  "_id",
  "_ttl",
  "_source",
  "_all",
  "_index",
  "_type",
  "_score",
  // Our reserved fields.
  "gl2_accounted_message_size",
  "gl2_input_message_size",
  "gl2_processing_error",
  "gl2_processing_duration_ms",
  "gl2_processing_timestamp",
  "gl2_receive_timestamp",
  "gl2_remote_hostname",
  "gl2_remote_ip",
  "gl2_remote_port",
  "gl2_source_collector",
  "gl2_source_collector_input",
  "gl2_source_input",
  "gl2_source_node",
  "gl2_message_id",
  STREAMS_FIELD,
  // TODO Due to be removed in Graylog 3.x
  "gl2_source_radio",
  "gl2_source_radio_input"
];
export const RESERVED_FIELDS = [
  FULL_MESSAGE_FIELD,
  MESSAGE_FIELD,
  TIMESTAMP_FIELD,
  SOURCE_FIELD,
  GL2_SECOND_SORT_FIELD
];
export const MISSING_BUCKET_NAME = "(Empty Value)";
export const DEFAULT_PIVOT_LIMIT = 15;
export const DEFAULT_PIVOT_INTERVAL = {
  type: "auto",
  scaling: 1
};
export const DEFAULT_MESSAGE_FIELDS = [TIMESTAMP_FIELD, SOURCE_FIELD];
export const RELATIVE_ALL_TIME = 0;
export const ALL_MESSAGES_TIMERANGE = { type: "relative", range: RELATIVE_ALL_TIME };
export const Messages = {
  DEFAULT_LIMIT: 150
};
export const DEFAULT_RANGE_TYPE = "relative";
export const DEFAULT_RELATIVE_FROM = 300;
export const DEFAULT_RELATIVE_TO = DEFAULT_RELATIVE_FROM - 60;
export const DEFAULT_TIMERANGE = { type: DEFAULT_RANGE_TYPE, from: DEFAULT_RELATIVE_FROM };
export const NO_TIMERANGE_OVERRIDE = {};
export const DEFAULT_HIGHLIGHT_COLOR = StaticColor.create("#ffec3d");
export const DEFAULT_CUSTOM_HIGHLIGHT_RANGE = chroma.scale(["lightyellow", "lightgreen", "lightblue", "red"]).mode("lch").colors(40);
export const DEFAULT_INTERPOLATION = "linear";
export const interpolationTypes = ["linear", "step-after", "spline"];
export const percentileOptions = [25, 50, 75, 90, 95, 99].map((value) => ({ label: value, value }));
export const percentageStrategyOptions = [
  { label: "Document Count", value: "COUNT" },
  { label: "Field Sum", value: "SUM" }
];
export const TimeUnits = {
  seconds: "Seconds",
  minutes: "Minutes",
  hours: "Hours",
  days: "Days",
  weeks: "Weeks",
  months: "Months"
};
export const RELATIVE_RANGE_TYPES = [
  {
    type: "seconds",
    label: "Seconds"
  },
  {
    type: "minutes",
    label: "Minutes"
  },
  {
    type: "hours",
    label: "Hours"
  },
  {
    type: "days",
    label: "Days"
  }
];
export const viewsPath = "/views";
export const showViewsPath = `${viewsPath}/:viewId`;
export const searchPath = "/search";
export const newSearchPath = `${searchPath}/new`;
export const showSearchPath = `${searchPath}/:viewId`;
export const dashboardsPath = "/dashboards";
export const newDashboardsPath = `${dashboardsPath}/new`;
export const dashboardsTvPath = (viewId = ":viewId") => `${dashboardsPath}/tv/${viewId}`;
export const showDashboardsPath = (viewId = ":viewId") => `${dashboardsPath}/${viewId}`;
export const extendedSearchPath = "/extendedsearch";
export const availableTimeRangeTypes = [
  { type: "relative", name: "Relative" },
  { type: "absolute", name: "Absolute" },
  { type: "keyword", name: "Keyword" }
];
export const VISUALIZATION_TABLE_HEADER_HEIGHT = 28;
export const keySeparator = "\u2E31";
export const humanSeparator = "-";
export const thresholdsSupportedVisualizations = ["bar", "area", "line", "scatter"];
export const multipleValuesActionsSupportedVisualizations = ["bar", "area", "line", "scatter"];
export const QUERY_TIME_RANGE_LIMIT_ERROR_TYPE = "query_time_range_limit";
export const SEARCH_TYPE_RANGE_LIMIT_ERROR_TYPE = "search_type_time_range_limit";
